import { render } from "./ReadPost.vue?vue&type=template&id=74116475"
import script from "./ReadPost.vue?vue&type=script&lang=js"
export * from "./ReadPost.vue?vue&type=script&lang=js"

import "./ReadPost.vue?vue&type=style&index=0&id=74116475&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__